import { styled } from 'styled-components';

import { UncontrolledListingTypeSelect } from 'modules/listing/components/ListingTypeSelect/UncontrolledListingTypeSelect';
import { searchTypes } from 'modules/search/constants/searchTypes';
import { trackEvent } from 'utils/analytics/track/trackEvent';

import { usePageHeaderSearchInputsDesktopContext } from './DesktopSearchBarContext';

const Holder = styled.div`
  max-width: 336px;
  flex: 1;
`;

export function DesktopSearchBarSearchTypeSelect() {
  const { defaultSearchType, setSearchTypeForPopularSearches } =
    usePageHeaderSearchInputsDesktopContext();

  return (
    <Holder>
      <UncontrolledListingTypeSelect
        // Reset component when initial value changes
        key={defaultSearchType}
        name="listing-type"
        defaultValue={defaultSearchType}
        searchTypes={searchTypes}
        variant="grey"
        onChange={(listingType) => {
          trackEvent('Changed Search Type', {
            filter_type: listingType,
            context: 'Header',
          });
          setSearchTypeForPopularSearches(listingType);
        }}
      />
    </Holder>
  );
}
